import { ISelectorEvent } from "../../interfaces/events";
import { ISpaceOnMap } from "../../interfaces/spaces";
export interface ISelectorExtensionOptions {
	onClickAsync: (context: ISelectorEvent) => Promise<void>;
	getSpaceById: (dbId: number) => ISpaceOnMap | undefined;
	context: SelectorExtensionContext;
}

export class SelectorExtensionContext {
	public selectedDbId: string = "";
	public selectionContext: ISelectorEvent;
}

export class SelectorExtension extends Autodesk.Viewing.Extension {
	private selectorOptions: ISelectorExtensionOptions;
	private context: SelectorExtensionContext;

	public constructor(viewer: Autodesk.Viewing.GuiViewer3D, options: ISelectorExtensionOptions) {
		super(viewer, options);
		this.context = options.context;
		this.selectorOptions = options;
		this.onSelectionHandler = this.onSelectionHandler.bind(this);
		this.onObjectClickHandlerAsync = this.onObjectClickHandlerAsync.bind(this);
	}

	public load(): boolean {
		this.viewer.addEventListener(Autodesk.DataVisualization.Core.MOUSE_CLICK, this.onObjectClickHandlerAsync);
		this.viewer.addEventListener(Autodesk.Viewing.SELECTION_CHANGED_EVENT, this.onSelectionHandler);
		return true;
	}

	public unload(): boolean {
		this.viewer.removeEventListener(Autodesk.DataVisualization.Core.MOUSE_CLICK, this.onObjectClickHandlerAsync);
		this.viewer.removeEventListener(Autodesk.Viewing.SELECTION_CHANGED_EVENT, this.onSelectionHandler);
		return true;
	}

	public async onObjectClickHandlerAsync(event: any): Promise<void> {
		event.hasStopped = true;
		if (event.clickInfo) {
			event.dbIdArray = [event.clickInfo.dbId];
			await this.onSelectionHandler(event);
		}
	}

	public async onSelectionHandler(event: any): Promise<void> {
		this.context.selectionContext = {};
		const dbId = event.dbIdArray[0];

		if (!dbId) {
			await this.selectorOptions.onClickAsync(this.context.selectionContext);
			return;
		}

		this.viewer.clearSelection();
		if (dbId === this.context.selectedDbId) {
			return;
		}

		this.context.selectedDbId = dbId;
		this.viewer.getProperties(dbId, async (result: Autodesk.Viewing.PropertyResult) => {
			const mapSpace = this.selectorOptions.getSpaceById(result.dbId);

			if (!mapSpace) {
				await this.selectorOptions.onClickAsync(this.context.selectionContext);
				return;
			}
			this.context.selectionContext = {
				space: mapSpace,
			};
			await this.selectorOptions.onClickAsync(this.context.selectionContext);
			this.context.selectedDbId = "";
		});
	}
}
